import React from "react";
import FormulaKatex from "./FormulaKatex";
import PrerequisChips from "./PrerequisChips";

const RegleCard = ({ regle, index, total }) => {
  const showIndex = total > 1;

  return (
    <div className="regles-calcul__regle">
      {showIndex && (
        <div className="regles-calcul__regle-index">
          Règle {index + 1} / {total}
        </div>
      )}
      {regle.formule && <FormulaKatex formula={regle.formule} />}
      <PrerequisChips requis={regle.requis} />
      {regle.description && (
        <p className="regles-calcul__regle-description">
          <i className="fas fa-info-circle mr-2" />
          {regle.description}
        </p>
      )}
    </div>
  );
};

export default RegleCard;
